<template lang="pug">
div
  PageTitle
  v-card
    v-alert(type='error' :value='true' v-if='vote === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}
    v-alert(type='error' :value='true' v-else-if='isSaveFailed && error' icon='warning') {{ $t('failedToSave') }} {{ error.response }}

  v-card(:raised='isModified')
    //- 存檔工具列
    v-toolbar(flat style={ transform: `none` })
      //- h6.warning--text
        v-icon.mr-1(small color='warning' v-if='') fas fa-exclamation-circle
        | #[b 人氣投票]功能目前為關閉狀態
      v-spacer
      v-menu(bottom right :disabled='isLoading')
        v-btn(slot='activator' icon)
          v-icon more_vert
        v-list(subheader)
          v-subheader 排序
          v-list-tile(@click='sortByVotes()')
            v-list-tile-avatar: v-icon fas fa-vote-yea
            v-list-tile-content 得票數多→少
            v-list-tile-action: v-icon(small) fas fa-sort-amount-up
          v-list-tile(@click='sortByVotes(false)')
            v-list-tile-avatar
            v-list-tile-content 得票數少→多
            v-list-tile-action: v-icon(small) fas fa-sort-amount-down
          v-list-tile(@click='sortByTime(false)')
            v-list-tile-avatar: v-icon fas fa-clock
            v-list-tile-content 報名時間升序
            v-list-tile-action: v-icon(small) fas fa-sort-numeric-down
          v-list-tile(@click='sortByTime()')
            v-list-tile-avatar
            v-list-tile-content 報名時間降序
            v-list-tile-action: v-icon(small) fas fa-sort-numeric-up
    Loader(:show='vote === null')

    //- 順序列表
    v-card-text(v-if='vote && length === 0')
      h6.grey--text 尚無當屆人氣投票結果

    v-list(subheader v-else-if='vote' two-line)
      transition-group(name='list')
        v-list-tile(v-for='(i, index) in vote' :key='JSON.stringify(i)' )
          v-list-tile-avatar(tile)
            v-icon(color='amber' v-if='i.numOfVote === maxVotes && i.numOfVote > 0') fas fa-trophy
          v-list-tile-content
            v-list-tile-title {{ i.name }} / {{ i.school || `社會組` }}
            v-list-tile-sub-title
              v-icon.mr-2(small) fas fa-music
              | {{ i.song }}
          v-list-tile-action
            div
              span.votes-number.primary--text {{ i.numOfVote }}
              small.mx-1 票
  DebugCodeBlock(:value='vote')
</template>

<script>
import apis from '@/assets/js/apis'

import { formStatus } from '@/mixins/formStatus'
import Loader from '@/components/Loader.vue'
import PageTitle from '@/components/PageTitle.vue'

export default {
  name: 'Vote',
  metaInfo () {
    return {
      title: this.$t('人氣投票'),
    }
  },
  data () {
    return {
      vote: null,
      menu: false,
    }
  },
  mounted () {
    if (this.period) this.fetch()
  },
  methods: {
    sortByTime (desc = true) {
      const items = this.vote
      this.vote = items.sort((a, b) => {
        const at = a.timestamp || 0
        const bt = b.timestamp || 0
        return desc ? bt - at : at - bt
      })
    },
    sortByVotes (desc = true) {
      const items = this.vote
      this.vote = items.sort((a, b) => {
        const at = a.numOfVote || 0
        const bt = b.numOfVote || 0
        return desc ? bt - at : at - bt
      })
    },
    async fetch () {
      const params = { period: this.period }

      try {
        this.vote = await apis.vote.get(params, this.token)
        this.sortByVotes(true)
      } catch (e) {
        this.error = e
        this.vote = false
      }
    },
  },
  computed: {
    isLoading () {
      return !this.vote
    },
    period () {
      return (this.$store.state.userInfo) ? this.$store.state.userInfo.period : null
    },
    length () {
      return this.vote ? this.vote.length : 0
    },
    maxVotes () {
      return this.vote ? Math.max(...this.vote.map(v => v.numOfVote)) : null
    },
  },
  watch: {
    vote: {
      handler (newValue, oldValue) {},
      deep: true,
    },
    period () {
      this.fetch()
    },
  },
  components: {
    Loader,
    PageTitle,
  },
  mixins: [formStatus],
}
</script>

<style scoped lang="sass">
.votes-number
  font-family: Roboto,sans-serif!important
  font-size: 18px

</style>
